import { makeApiProvider } from '@pflegenavi/shared-frontend/platform';
import { createContext } from 'react';
import type { IStripePhoenixApi, CreateStripeAccountResponse } from './api';
import { StripePhoenixApi } from './api';
import type {
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { useMutation } from '@tanstack/react-query';

const ApiContext = createContext<IStripePhoenixApi | undefined>(undefined);
const { useApi: useStripeApi, ApiProvider: StripePhoenixApiProvider } =
  makeApiProvider({
    name: 'Stripe',
    ApiContext,
    newApi: (tenantId, auth, apiUrl) =>
      new StripePhoenixApi(tenantId, auth, apiUrl),
  });

export { StripePhoenixApiProvider };

export const useCreateStripeAccountPhoenix = (
  options?: Omit<
    UseMutationOptions<CreateStripeAccountResponse, unknown, void>,
    'mutationFn'
  >
): UseMutationResult<CreateStripeAccountResponse, unknown, void> => {
  const api = useStripeApi();
  return useMutation({
    mutationFn: () => api.createStripeAccount(),
    ...options,
  });
};
